import { render, staticRenderFns } from "./brandBuilding.vue?vue&type=template&id=6668e218&scoped=true"
import script from "./brandBuilding.vue?vue&type=script&lang=js"
export * from "./brandBuilding.vue?vue&type=script&lang=js"
import style0 from "./brandBuilding.vue?vue&type=style&index=0&id=6668e218&prod&scoped=scoped&lang=scss"
import style1 from "./brandBuilding.vue?vue&type=style&index=1&id=6668e218&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6668e218",
  null
  
)

export default component.exports